import React from 'react';
import PropTypes from 'prop-types';
import './InfoNotice.css';

/**
 * A reusable component for displaying information notices with icons
 */
const InfoNotice = ({ 
  icon = 'info-circle', 
  children, 
  className = '', 
  variant = 'info',
  onClick = null,
}) => {
  const isClickable = !!onClick;
  
  return (
    <div 
      className={`info-notice info-notice--${variant} ${isClickable ? 'info-notice--clickable' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="info-notice__icon">
        <i className={`fas fa-${icon}`}></i>
      </div>
      <div className="info-notice__content">
        {children}
      </div>
    </div>
  );
};

InfoNotice.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
  onClick: PropTypes.func
};

export default InfoNotice;